import { logoApp } from "../iconos";

// Se entra SOLO con Google, los locales y administracion por igual: no hay
// usuario ni clave. El boton es un link comun a /api/google/iniciar, que sale
// a Google y vuelve con la sesion puesta.

// Por que no se pudo entrar con Google. functions/api/google/volver.ts vuelve
// a esta pantalla con ?google=<codigo>; el codigo nunca trae el correo.
const AVISOS_GOOGLE: Record<string, string> = {
  sin_acceso:
    "Esa cuenta de Google no tiene acceso. Probá con otra cuenta, o pedile a la confitería que cargue tu correo.",
  cancelado: "No se completó el ingreso con Google. Probá de nuevo.",
  vencido: "El ingreso tardó demasiado. Tocá de nuevo «Entrar con Google».",
  config: "El ingreso con Google todavía no está configurado. Avisale a la confitería.",
  error: "Google no pudo confirmar tu cuenta. Probá de nuevo en un momento.",
};

// La "G" de Google, con sus colores. Va dibujada aca para no cargar nada de
// afuera en la pantalla de entrada.
const logoGoogle = `<svg viewBox="0 0 48 48" class="h-5 w-5 shrink-0" aria-hidden="true">
  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
</svg>`;

/** Lee ?google=... y lo saca de la barra de direcciones, para que no quede. */
function avisoDeGoogle(): string {
  const params = new URLSearchParams(location.search);
  const codigo = params.get("google");
  if (!codigo) return "";
  history.replaceState(null, "", location.pathname + location.hash);
  return AVISOS_GOOGLE[codigo] ?? AVISOS_GOOGLE.error;
}

export function renderLogin(contenedor: HTMLElement): void {
  // Si el usuario fue desplazado por un login del mismo usuario en otro lado,
  // api.ts dejo este flag antes de recargar: mostramos un aviso.
  const desplazado = sessionStorage.getItem("sesionCerrada") === "1";
  sessionStorage.removeItem("sesionCerrada");
  const avisoGoogle = avisoDeGoogle();

  contenedor.innerHTML = `
    <div class="mx-auto mt-12 max-w-sm sm:mt-20">
      <div class="tarjeta">
        <div class="mb-1 flex items-center gap-2 text-2xl font-bold text-masa-900">
          ${logoApp("h-10 w-10")} Piedra y Sol
        </div>
        <p class="mb-5 text-sm text-masa-500">Pedidos, producción y cuentas.</p>
        ${desplazado ? `<p class="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">Tu sesión se cerró porque se inició sesión con este usuario en otro dispositivo.</p>` : ""}

        <a id="google" href="/api/google/iniciar"
           class="flex w-full items-center justify-center gap-3 rounded-lg border border-crema-300 bg-papel px-4 py-3 font-medium text-masa-900 transition hover:bg-crema-50 active:bg-crema-100">
          ${logoGoogle} Entrar con Google
        </a>
        ${
          avisoGoogle
            ? `<p id="errGoogle" class="mt-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">${avisoGoogle}</p>`
            : `<p class="mt-2 text-xs text-masa-500">Con la cuenta de Google cuyo correo tenés cargado en el sistema. No hay clave que acordarse.</p>`
        }

      </div>
      <p class="mt-4 text-center text-xs text-masa-400">
        <a href="/privacidad" class="underline-offset-2 hover:underline">Política de privacidad</a>
      </p>
    </div>`;

}
